exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-summary-container {\r\n    padding: 20px;\r\n    background: #ddd;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n/* needs a little work -- would like this border to stretch higher and not depend on content-height */\r\n.balance-border {\r\n    border-right: 1px #000 solid;\r\n}\r\n\r\n.total-balance {\r\n    font-size: 22px;\r\n}\r\n\r\n@media(max-width:767px){\r\n.vertical-balance{\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n}", ""]);

// exports
